export const generate = (): string => {
  return `_${Math.random().toString(36).substr(2, 9)}`;
};

export const generateByKey = (key: string, prefix = "id"): string => {
  return `_${prefix}-${key}`;
};
